import { theme } from 'styles/theme'

export interface PlanTag {
  text: string
  fontColor: string
  bgcolor: string
}

export const planTagMapper: Record<string, PlanTag> = {
  free: {
    text: 'Free',
    fontColor: theme.palette.neutral[400],
    bgcolor: '#fff'
  },
  basic: {
    text: 'Basic',
    fontColor: theme.palette.neutral[200],
    bgcolor: theme.palette.primary.main
  },
  basic_mei: {
    text: 'Basic',
    fontColor: theme.palette.neutral[200],
    bgcolor: theme.palette.primary.main
  },
  basic_cora: {
    text: 'CORA',
    fontColor: '#fff',
    bgcolor: '#FF0066'
  },
  pro: {
    text: 'PRO',
    fontColor: '#fff',
    bgcolor: theme.palette.info[200]
  },
  ultra: {
    text: 'Ultra',
    fontColor: '#fff',
    bgcolor: theme.palette.neutral[200]
  },
  plan_trial: {
    text: 'TRIAL',
    fontColor: '#fff',
    bgcolor: theme.palette.warning.main
  },
  start: {
    text: 'START',
    fontColor: theme.palette.neutral[200],
    bgcolor: theme.palette.primary.main
  },
  grow: {
    text: 'GROW',
    fontColor: '#fff',
    bgcolor: theme.palette.info[200]
  },
  scale: {
    text: 'SCALE',
    fontColor: '#fff',
    bgcolor: theme.palette.neutral[200]
  },
  lite: {
    text: 'LITE',
    fontColor: '#fff',
    bgcolor: theme.palette.success.main
  }
}

export const getPlanTag = (plan?: string): PlanTag =>
  (plan && planTagMapper[plan]) || planTagMapper.free
